import React from 'react';

import {
  ApprovalTypeName,
  ReturnAuthorizationsActivity_TabBarDocument,
  useApproveReturnAuthorizationMutation
} from 'generated/graphql';



export function useApproveReturnAuthorization(returnAuthorizationId: string, storeId?: string) {
  const [fnMutate, tuple] = useApproveReturnAuthorizationMutation({
    awaitRefetchQueries: true,
    refetchQueries: [{
      query: ReturnAuthorizationsActivity_TabBarDocument,
      variables: { storeId }
    }]
  });

  const fnWrappedMutate = React.useCallback(
    async (approvalTypeName: ApprovalTypeName) => {
      await fnMutate({
        variables: {
          approvalTypeName,
          returnAuthorizationId
        }
      });
    },
    [
      fnMutate,
      returnAuthorizationId
    ]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
